<template>
  <div @keyup.enter="login" class="bg-login m-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center">
    <div class="bg-login2 w-100 h-100 d-flex flex-column align-items-center justify-content-center">
      <img class="logo mb-2" src="@/assets/img/logo-h-v2.svg">
      <form class="d-flex flex-column justify-content-center align-items-center">
        <div class="input my-2 input-user d-flex flex-row align-items-center justify-content-start">
          <svg class="me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 39.5-161.2c77.2 12 136.3 78.8 136.3 159.4c0 17-13.8 30.7-30.7 30.7H265.1 182.9 30.7C13.8 512 0 498.2 0 481.3c0-80.6 59.1-147.4 136.3-159.4l39.5 161.2 33.4-123.9z" />
          </svg>
          <input type="text" placeholder="Usuario:" v-model="user">
        </div>
        <div class="input my-2 input-pass d-flex flex-row align-items-center justify-content-start">
          <svg class="me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zm40-176c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40z" />
          </svg>
          <input type="password" placeholder="Contraseña:" v-model="password">
        </div>
        <div class="btn-login my-2 py-2" @click="login">
          <p class="m-0">Iniciar Sesión</p>
        </div>
      </form>
      <img class="earth" src="@/assets/img/earth7.svg">
    </div>
  </div>
</template>

<script lang="ts">
import SessionService from '@/api/services/session.service';
import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class Login extends Vue {

  password = ''
  user = ''

  async login() {
    if ((this.password != '') && (this.user != '')) {
      await SessionService.login(this.user, this.password)
        .catch((e) => {
          alert('Usuario o Contraseña Incorrecta')
          console.log(e)
          this.user = ''
          this.password = ''
        })
    } else {
      alert('Se requiere Usuario y Contraseña')
    }
  }
  
}
</script>

<style lang="sass" scoped> 
  @import '@/assets/style/variables.sass'
  @import '@/assets/style/login-efects.css'
  .earth
    width: 130%
    position: fixed
    z-index: -2
    bottom: -19em
    max-width: 500px
  .logo
    width: 90%
    max-width: 450px
    filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.8))
  form
    background-image: url("@/assets/img/form-login.svg")
    background-position: center
    background-size: cover
    background-repeat: no-repeat
    width: 90%
    max-width: 450px
    height: 350px
    .btn-login
      width: 80%
      background: $dark
      color: #fff
      border-radius: 5px
    .input
      width: 80%
      border: 2px solid $secondary
      padding: 5px 10px
      border-radius: 5px
      background: #fff
      svg
        fill: $secondary
        height: 30px
      input
        padding: 5px
        font-size: 18px
        border: none
        color: #343a40
        max-width: 200px
        &:focus-visible
          border: none
          outline: none
</style>
